module.exports = __webpack_public_path__ + "img/geboortekaart-op-maat-Jakob-jongen-foliedruk-afgeronde-hoeken-aquarel-drukwerk-3.b7974264.jpg";